import { StakingStatus, StakePeriodType } from "../enums/club.enums";

export interface IClubColumns {
  id:
    | "address"
    | "name"
    | "imageUrl"
    | "owner"
    | "governanceType"
    | "createdAt";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: any) => React.ReactNode | any;
}

export enum ClubType {
  DepositBased = 0,
  RoleBased = 2,
  NftBased = 3,
}

export interface IClubData {
  address: string;
  imageUrl: string;
  name: string;
  owner: string;
  governanceType: ClubType;
  createdAt: Date;
}
export interface IClubsOverview {
  total: number;
  active: number;
  roleBased: number;
  depositBased: number;
  nftBased: number;
}
export interface IClubsTableInfo {
  imageUrl: string;
  name: string;
  address: string;
  value: number;
}
export interface IClubMembers {
  total: number;
  founder: number;
  manager: number;
  member: number;
}

export interface IStakingAccount {
  stakingAddress: string;
  capAmount: number;
  rasiedAmount: number;
  name: string;
  stakePeriodEnd: Date | null;
  stakingStatus: StakingStatus;
  stakePeriodType: StakePeriodType;
}

export interface IStakingTableItems {
  rasiedAmount: number;
  name: string;
  stakingStatus: string;
}

export interface IClubStakings {
  totalStakedAmount: number;
  stakingAccounts: IStakingAccount[];
}

export interface IProposalStatus {
  voting: number;
  succedeed: number;
  executing: number;
  cancelled: number;
  defeated: number;
  completed: number;
}

export interface IProposalType {
  trading: number;
  withdrawal: number;
  discussion: number;
}

export interface IClubProposals {
  total: number;
  proposalStatus: IProposalStatus;
  proposalType: IProposalType;
  maxVotingTime: number;
  defaultApprovalQuorum: number;
  withdrawalApprovalQuorum: number | undefined;
  sellPermissionsQuorum: number[];
}

export interface IClubTreasuryOverview {
  hasActiveFundraise: boolean;
  raisedAmountForFundraise: number;
  capAmountForFundriase: number;
  totalRaisedAmount: number;
  balance: number;
  totalFinancialAccountAmount: number;
  totalNumberOfNfts: number;
}

export interface IClubTag {
  value: string;
  label: string;
  isVerified: boolean;
}

export interface IClubBasicInfo {
  address: string;
  imageUrl: string;
  name: string;
  owner: string;
  governanceType: ClubType;
  email: string;
  applicationStatus: string;
  createdAt: Date;
  tags: IClubTag[];
  ownersPubKey: string;
  isHidden?: boolean;
}

export interface IClubVisibilityStatus {
  isHidden: boolean;
}

export interface INftMintDto {
  mint: string;
  price: number;
}

export interface ITradingTableInfoDto {
  buys: INftMintDto[];
  sells: INftMintDto[];
}

export interface ITradingInfo {
  mint: string;
  price: number;
  nftImg: string;
  nftName: string;
}

export interface ITradingTableInfo {
  buys: ITradingInfo[];
  sells: ITradingInfo[];
}
export interface IWithdrawalOverview {
  totalWithdrawalAmount: number;
  withdrawalCount: number;
}

export interface IToggleClubVisibility {
  isHidden: boolean;
}
